<div class="container-fluid bg-light">
  <div class="container inner-container">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" [routerLink]="['']">
          <img class="desktop" src="assets\logo.png">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mr-2">
            <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a class="nav-link" routerLink="home">Home</a></li> -->
            <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLink="location">Locations</a></li>
            <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLink="properties">Properties</a></li>
            <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLink="services">Our Services</a></li>
            <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLink="pricing">Pricing</a></li>
            <li class="nav-item" routerLinkActive="active"><a class="nav-link" routerLink="blogs">Blog</a></li>
            <!-- <li class="nav-item" routerLinkActive="active"><a class="nav-link special" routerLink="add-property/step-1">Add Your Property</a></li> -->
        </ul>
          <div class="form-inline my-2 my-lg-0">
            <div *ngIf="!loggedInStatus" class="nav-buttons"> 
                <a mat-raised-button class="theme-button" routerLink="login">Add Your Property</a>
            </div>
            <div *ngIf="loggedInStatus && userProfile" class="dropdown nav-buttons">
                <a mat-raised-button class="theme-button mr-2" routerLink="add-property/step-1">Add Your Property</a>
                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <img *ngIf="selectedImage" class="icon-image" [src]="selectedImage" alt="">
                  <img *ngIf="!selectedImage" class="icon-image" src="assets/account.png" alt=""> {{ userProfile.firstName }} {{ userProfile.lastName }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" [routerLink]="['/profile/basic-info']">Profile</a>
                  <a class="dropdown-item" [routerLink]="['/add-property/step-1']">Add Property</a>
                  <a class="dropdown-item" (click)="logOut()">Log Out</a>
                </div>
            </div>
          </div>
        </div>
    </nav>
</div>
</div>